export const MANAGE_HPOOL_TAG = 'MANAGE_HPOOL_TAG';

export const SET_CREATE_TICKETS_ALERT = 'SET_CREATE_TICKETS_ALERT';
export const SET_CHOOSE_TOKENS_ALERT = 'SET_CHOOSE_TOKENS_ALERT';

export const UPDATE_HPOOL = 'UPDATE_HPOOL';

export const LOAD_POOL_SAFTS = 'LOAD_POOL_SAFTS';

export const SET_CREATE_HPOOL_STEP_FINISHED = 'SET_CREATE_HPOOL_STEP_FINISHED';

export const SET_CREATE_HPOOL_CHOOSE_TOKENS_SEARCH = 'SET_CREATE_HPOOL_CHOOSE_TOKENS_SEARCH';

export const FETCH_MOST_USED_TOKENS_REQUEST = 'FETCH_MOST_USED_TOKENS_REQUEST';
export const FETCH_MOST_USED_TOKENS_SUCCESS = 'FETCH_MOST_USED_TOKENS_SUCCESS';
export const FETCH_MOST_USED_TOKENS_FAILURE = 'FETCH_MOST_USED_TOKENS_FAILURE';

export const CREATE_HPOOL_SEARCH_TOKENS_REQUEST = 'CREATE_HPOOL_SEARCH_TOKENS_REQUEST';
export const CREATE_HPOOL_SEARCH_TOKENS_SUCCESS = 'CREATE_HPOOL_SEARCH_TOKENS_SUCCESS';
export const CREATE_HPOOL_SEARCH_TOKENS_FAILURE = 'CREATE_HPOOL_SEARCH_TOKENS_FAILURE';

export const CREATE_HPOOL_ADD_TOKEN = 'CREATE_HPOOL_ADD_TOKEN';

export const CREATE_HPOOL_CHANGE_TOKENS_PERCENTAGE = 'CREATE_HPOOL_CHANGE_TOKENS_PERCENTAGE';

export const CREATE_HPOOL_CHANGE_TOKEN_LOCK_VALUE = 'CREATE_HPOOL_CHANGE_TOKEN_LOCK_VALUE';

export const CREATE_HPOOL_DELETE_TOKEN = 'CREATE_HPOOL_DELETE_TOKEN';

export const GET_CHAMPION_NFT_IMAGE_REQUEST = 'GET_CHAMPION_NFT_IMAGE_REQUEST';
export const GET_CHAMPION_NFT_IMAGE_SUCCESS = 'GET_CHAMPION_NFT_IMAGE_SUCCESS';
export const GET_CHAMPION_NFT_IMAGE_FAILURE = 'GET_CHAMPION_NFT_IMAGE_FAILURE';

export const ASSIGN_HPOOL_NFT_REQUEST = 'ASSIGN_HPOOL_NFT_REQUEST';
export const ASSIGN_HPOOL_NFT_SUCCESS = 'ASSIGN_HPOOL_NFT_SUCCESS';
export const ASSIGN_HPOOL_NFT_FAILURE = 'ASSIGN_HPOOL_NFT_FAILURE';

export const GET_TICKET_INFO_REQUEST = 'GET_TICKET_INFO_REQUEST';
export const GET_TICKET_INFO_SUCCESS = 'GET_TICKET_INFO_SUCCESS';
export const GET_TICKET_INFO_FAILURE = 'GET_TICKET_INFO_FAILURE';

export const GET_MIN_DEPOSIT_VALUE_REQUEST = 'GET_MIN_DEPOSIT_VALUE_REQUEST';
export const GET_MIN_DEPOSIT_VALUE_SUCCESS = 'GET_MIN_DEPOSIT_VALUE_SUCCESS';
export const GET_MIN_DEPOSIT_VALUE_FAILURE = 'GET_MIN_DEPOSIT_VALUE_FAILURE';

export const GET_CHAMPION_NFT_REQUEST = 'GET_CHAMPION_NFT_REQUEST';
export const GET_CHAMPION_NFT_SUCCESS = 'GET_CHAMPION_NFT_SUCCESS';
export const GET_CHAMPION_NFT_FAILURE = 'GET_CHAMPION_NFT_FAILURE';

export const CLEAR_HPOOL_DRAFT = 'CLEAR_HPOOL_DRAFT';
export const UPDATE_BASE_TOKENS = 'UPDATE_BASE_TOKENS';

export const UPDATE_CHAMPION_NFT_REQUEST = 'UPDATE_CHAMPION_NFT_REQUEST';
export const UPDATE_CHAMPION_NFT_SUCCESS = 'UPDATE_CHAMPION_NFT_SUCCESS';
export const UPDATE_CHAMPION_NFT_FAILURE = 'UPDATE_CHAMPION_NFT_FAILURE';

export const GET_CHAMPION_DRAFT_POOL_REQUEST = 'GET_CHAMPION_DRAFT_POOL_REQUEST';
export const GET_CHAMPION_DRAFT_POOL_SUCCESS = 'GET_CHAMPION_DRAFT_POOL_SUCCESS';
export const GET_CHAMPION_DRAFT_POOL_FAILURE = 'GET_CHAMPION_DRAFT_POOL_FAILURE';

export const SUBMIT_CREATE_HPOOL_REQUEST = 'SUBMIT_CREATE_HPOOL_REQUEST';
export const SUBMIT_CREATE_HPOOL_SUCCESS = 'SUBMIT_CREATE_HPOOL_SUCCESS';
export const SUBMIT_CREATE_HPOOL_FAILURE = 'SUBMIT_CREATE_HPOOL_FAILURE';

export const CREATE_UPDATE_HPOOL_REQUEST = 'CREATE_UPDATE_HPOOL_REQUEST';
export const CREATE_UPDATE_HPOOL_SUCCESS = 'CREATE_UPDATE_HPOOL_SUCCESS';
export const CREATE_UPDATE_HPOOL_FAILURE = 'CREATE_UPDATE_HPOOL_FAILURE';

export const GET_INIT_DEPO_REQUEST = 'GET_INIT_DEPO_REQUEST';
export const GET_INIT_DEPO_SUCCESS = 'GET_INIT_DEPO_SUCCESS';
export const GET_INIT_DEPO_FAILURE = 'GET_INIT_DEPO_FAILURE';

export const GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_REQUEST = 'GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_REQUEST';
export const GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_SUCCESS = 'GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_SUCCESS';
export const GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_FAILURE = 'GET_CREATE_HPOOL_DEPOSIT_FUNDS_DATA_FAILURE';

export const GET_TAGS_REQUEST = 'GET_TAGS_REQUEST';
export const GET_TAGS_SUCCESS = 'GET_TAGS_SUCCESS';
export const GET_TAGS_FAILURE = 'GET_TAGS_FAILURE';

export const UPDATE_TAGS = 'UPDATE_TAGS';

export const GET_HPOOL_REQUEST = 'GET_HPOOL_REQUEST';
export const GET_HPOOL_SUCCESS = 'GET_HPOOL_SUCCESS';
export const GET_HPOOL_FAILURE = 'GET_HPOOL_FAILURE';

export const DEPOSIT_HPOOL_SUCCESS = 'DEPOSIT_HPOOL_SUCCESS';
export const DEPOSIT_HPOOL_REQUEST = 'DEPOSIT_HPOOL_REQUEST';
export const DEPOSIT_HPOOL_FAILURE = 'DEPOSIT_HPOOL_FAILURE';

export const SET_HPOOL_STATS_SUCCESS = 'SET_HPOOL_STATS_SUCCESS';
export const SET_HPOOL_STATS_REQUEST = 'SET_HPOOL_STATS_REQUEST';
export const SET_HPOOL_STATS_FAILURE = 'SET_HPOOL_STATS_FAILURE';

export const MANAGE_HPOOL_REPLACE_TOKENS = 'MANAGE_HPOOL_REPLACE_TOKENS';

export const SET_ASSET_SIGNATURES = 'SET_ASSET_SIGNATURES';

export const RESET_CREATE_HPOOL_ERROR_MESSAGE = 'RESET_CREATE_HPOOL_ERROR_MESSAGE';

export const SET_CURRENT_TAB = 'SET_CURRENT_TAB';

export const UPDATE_TRADE_ORDERS = 'UPDATE_TRADE_ORDERS';

export const SET_WHITELISTED_POOLS = 'SET_WHITELISTED_POOLS';
export const SET_VPOOL_FLAG = 'SET_VPOOL_FLAG';

export const GET_HPOOL_SAFTS_REQUEST = 'GET_HPOOL_SAFTS_REQUEST';
export const GET_HPOOL_SAFTS_SUCCESS = 'GET_HPOOL_SAFTS_SUCCESS';
export const GET_HPOOL_SAFTS_FAILURE = 'GET_HPOOL_SAFTS_FAILURE';

export const SET_HAS_COMPLETED_SAFTS_STEP = 'SET_HAS_COMPLETED_SAFTS_STEP';
// export const CREATE_HPOOL_ADD_TOKEN_UNSAVED = 'CREATE_HPOOL_ADD_TOKEN_UNSAVED';
// export const CREATE_HPOOL_CHANGE_TOKENS_PERCENTAGE_UNSAVED = 'CREATE_HPOOL_CHANGE_TOKENS_PERCENTAGE_UNSAVED';
// export const CREATE_HPOOL_CHANGE_TOKEN_LOCK_VALUE_UNSAVED = 'CREATE_HPOOL_CHANGE_TOKEN_LOCK_VALUE_UNSAVED';
// export const CREATE_HPOOL_DELETE_TOKEN_UNSAVED = 'CREATE_HPOOL_DELETE_TOKEN_UNSAVED';
